<!--
Author: TangChen
Date: 2018-09-05
Desc: 系统错误页面组件，由router.js 配置引入
-->
<template>
    <div class="view-error-general view" :style="{ 'min-height': height + 'px' }">
        <div
            class="error"
            :style="{ 'margin-top': height - 343 > 0 ? (height - 343) / 2 + 'px' : '0px' }"
        >
            <img :src="require('../../assets/img/error-general.png')" alt="error" />
            <div class="error-text">
                <h1>oops...</h1>
                <p class="title">系统出现未知故障</p>
                <p>很抱歉，系统似乎出现了一点故障，我们的工程师正在进行抢修，请您稍候再试！</p>
                <el-button type="primary" v-on:click="loadRefresh">重 试</el-button>
                <el-button type="warning" v-on:click="loadToHome">返回首页</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            height: document.documentElement.clientHeight - 247
        };
    },
    mounted() {
        const _this = this;
        window.onresize = () => {
            _this.height = document.documentElement.clientHeight - 247;
        };
    },
    methods: {
        loadToHome() {
            if (this.$store.state.login.status) {
                this.$router.replace("/home");
            } else {
                this.$router.replace("/");
            }
        },
        loadRefresh() {
            this.$router.go(-1);
        }
    }
};
</script>
<style lang="scss">
.view-error-general {
    text-align: center;
    .error {
        width: 790px;
        display: inline-block;
        vertical-align: middle;
    }
    .error img {
        vertical-align: middle;
    }

    .error .error-text {
        vertical-align: middle;
        margin-left: 55px;
        width: 450px;
        text-align: left;
        display: inline-block;
    }

    .error .error-text h1 {
        color: #008cd4;
        font-size: 100px;
    }
    .error .error-text .title {
        color: #008cd4;
        font-size: 36px;
        margin: 20px 0;
        line-height: 40px;
    }
    .error .error-text p {
        color: #999999;
        font-size: 18px;
        line-height: 36px;
    }

    .error .error-text button {
        margin-top: 36px;
    }
    .error .error-text .last {
        margin-left: 20px;
    }
}
</style>
